import { render, staticRenderFns } from "./GiamSatTaiChinh.vue?vue&type=template&id=baf891e0&scoped=true"
import script from "./GiamSatTaiChinh.vue?vue&type=script&lang=ts"
export * from "./GiamSatTaiChinh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf891e0",
  null
  
)

export default component.exports